export default __webpack_public_path__ + "static/media/وحید غفاری.a12c2a92.jpg";